module.exports = __webpack_public_path__ + "assets/SAMSUNG_25_5_ikony_sft_KR_ready-02.4e617787.svg";